import { createI18n } from 'vue-i18n';
import { DEFAULT_LANGUAGE } from '../utils/constants';
import { getLanguageFromClient } from '../utils/language';
import zhCN from '../locales/zh-CN.yaml';
import enUS from '../locales/en-US.yaml';

export type I18n = ReturnType<typeof createI18n>;

const i18n = createI18n({
  locale: getLanguageFromClient(),
  fallbackLocale: {
    'en-US': [DEFAULT_LANGUAGE],
  },
  legacy: false,
  allowComposition: true,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
});

export default i18n;
